import { useDispatch, useSelector } from 'react-redux'
import { fixAdd } from '../../../helpers/math'
import {
  changeShareHolderActiveIndex,
  filterTable,
  selectOwnershipStructure,
  selectShareHolderActiveIndex,
} from '../store/slice'
import { colorChart, OTHER_ID } from './constants'
import { getFiveItems } from './helper'
import { PieChartComponent } from './pieChartComponent'

const getData = (data) => {
  const structureWithoutOther = Object.values(data).filter(
    (item) => item.ownerId !== -1 && item.ownerId !== -2,
  )

  const fiveItems = getFiveItems(structureWithoutOther, 'percentage')

  const formatItems = fiveItems.map((item, index) => {
    return {
      index,
      ownerId: item.ownerId,
      isI18n: false,
      name: item.ownershipName,
      value: item.percentage,
      color: colorChart[index],
    }
  })

  const sumPercentage = formatItems.reduce(
    (sum, item) => fixAdd(sum, item.value),
    0,
  )

  if (sumPercentage >= 1) {
    return formatItems
  }

  return [
    ...formatItems,
    {
      index: formatItems.length,
      ownerId: OTHER_ID,
      isI18n: true,
      name: 'companyAnalysis.ownershipAndGroup.OTHERS',
      value: 1 - sumPercentage,
      color: colorChart[formatItems.length],
    },
  ]
}

export const ShareHolder = () => {
  const dispatch = useDispatch()

  const activeIndex = useSelector(selectShareHolderActiveIndex)
  const data = useSelector(selectOwnershipStructure)
  const fiveItemsWithOther = getData(data)

  const filterShareholder = ({ ownerId, index }) => {
    if (activeIndex !== index) {
      dispatch(changeShareHolderActiveIndex(index))
      dispatch(
        filterTable({
          ownerId: {
            key: 'ownerId',
            ownerId,
            exceptIds: fiveItemsWithOther.map((item) => item.ownerId),
          },
        }),
      )
    } else {
      dispatch(changeShareHolderActiveIndex())
      dispatch(
        filterTable({
          ownerId: {},
        }),
      )
    }
  }

  return (
    <PieChartComponent
      onPieClick={filterShareholder}
      data={fiveItemsWithOther}
      title="companyAnalysis.ownershipAndGroup.MAJOR_SHAREHOLDERS"
      activeIndex={activeIndex}
    />
  )
}
